module.exports = __webpack_public_path__ + "img/SWP_Sword_1H_03.0f22e99e.png";